<p style="padding-left: 32px; font-size: 18px;">{{ !confirmed ? 'Conferma del preventivo in corso...' : 'Preventivo confermato.'}}</p>
